import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { CustomersService } from '../../services/customers/customers-service';

import { Customer } from '../../models/customer';

import { CustomerOverviewPage } from '../customer-overview/customer-overview';
import { CustomerDetailPage } from '../customer-detail/customer-detail';
import { CustomerVehiclePage } from '../customer-vehicle/customer-vehicle';
import { CustomerBillingPage } from '../customer-billing/customer-billing';


/**
 * Generated class for the CustomerTabsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-customer-tabs',
  templateUrl: 'customer-tabs.html',
})
export class CustomerTabsPage {

  public Customer: Customer;

  public customerOverviewRoot: any = CustomerOverviewPage;
  public customerDetailRoot: any = CustomerDetailPage;
  public customerVehicleRoot: any = CustomerVehiclePage;
  public customerBillingRoot: any = CustomerBillingPage;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public custService: CustomersService) {
      this.Customer = this.custService.get();
  }
}



// WEBPACK FOOTER //
// ./src/pages/customer-tabs/customer-tabs.ts